import React from 'react'
import undefsafe from 'undefsafe'

export default ({ error }) => {
  const errorMsg = undefsafe(error, 'response.status') === 404
    ? 'Sorry this item is no longer for sale.'
    : 'Hmm, looks like we can\'t load the matrix of this item.'

  return (
    <div className='fds-c-modal__section fds-u-text-align-center fds-u-p3'>
      <p className='fds-c-text-body fds-u-mb0'>
        {errorMsg}
      </p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/components/modals/cart/loadItemMatrixError.js